import { create, StateCreator } from "zustand"
import { devtools, persist, PersistOptions } from "zustand/middleware"

type ConfigureStoreOptions<T, P = T> = {
  persistOptions?: Omit<PersistOptions<T, P>, "version">
}

export type StoreWithDevtools<T> = StateCreator<T, [], [["zustand/devtools", never]]>
export type StoreWithPersist<T> = StateCreator<T, [], [["zustand/persist", T]]>
export type StoreWithBoth<T> = StateCreator<
  T,
  [],
  [["zustand/devtools", never], ["zustand/persist", T]]
>

export const configureStore = <T extends object, P = T>(
  initializer: StateCreator<T, [], []>,
  options: ConfigureStoreOptions<T, P> = {}
) => {
  if (options.persistOptions) {
    return create<T>()(devtools(persist(initializer, options.persistOptions)))
  }

  return create<T>()(devtools(initializer))
}
